import { useCallback } from 'react'

import { useStore } from '../store'
import { useBackupPreset } from './useBackupPreset'

export const useColumnsPreset = () => {
	const activePreset = useStore((state) => state.activePreset)
	const setActivePreset = useStore((state) => state.setActivePreset)

	const { handleLoadBackupPreset } = useBackupPreset()
	const backToFreeView = useCallback(() => {
		setActivePreset('__my__')
		handleLoadBackupPreset()
	}, [handleLoadBackupPreset, setActivePreset])

	return {
		activePreset,
		backToFreeView,
	}
}
